module.exports = __webpack_public_path__ + "static/media/escpBusinessSchoolLogo.dc14d8ba.jpg";